import { render, staticRenderFns } from "./x-expand-alert.vue?vue&type=template&id=5c48b0fb&scoped=true&"
import script from "./x-expand-alert.ts?vue&type=script&lang=ts&"
export * from "./x-expand-alert.ts?vue&type=script&lang=ts&"
import style0 from "./x-expand-alert.vue?vue&type=style&index=0&id=5c48b0fb&prod&lang=scss&"
import style1 from "./x-expand-alert.vue?vue&type=style&index=1&id=5c48b0fb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c48b0fb",
  null
  
)

export default component.exports